const ja = {
  nav: {
    home: "トップページ",
    product: "製品",
    QA: "よくある質問",
    explore: "今すぐ行きましょう",
    login: "ログイン",
    register: "登録する",
    registerNow: "今すぐ登録してください",
    demoStore: "今すぐ試してください",
    slideTitle: "世界的な買収",
    slideTitleSplit: "50億人の消費者をターゲットに",
    slideChoiceTitle: "品質の選択",
    slideBrandTitle: "世界的に有名なブランドからの信頼",
    footerAgreement: "特約店サービス契約",
    email: "相談メール",
    back: "戻る"
  },
  feature: {
    coverage: "<strong> は、世界中の </strong>71 の国と地域、<br />266 の支払い方法、および 50 以上の通貨をカバーしています。",
    optimization: "支払いプロセスの各主要ノードを最適化し、<br /><strong> により支払い成功率</strong> を向上させます。",
    ecological: "オープンな決済エコシステムと API システム、<br /> は、インターフェイス <strong> <strong> の高可用性と安定性を保証します。",
    compliance: "この決済ライセンスは米国、日本、ヨーロッパ、香港、中国をカバーしており、広範な<br />グローバル協同組合銀行ネットワークと<strong>グローバルコンプライアンス決済システム</strong>を備えています。",
    fraud: "リスク戦略とデータ モデルを通じて、当社はさまざまな角度から包括的な <br /> リアルタイム トランザクション監視を実装し、<strong> 詐欺防止</strong> を実行します。",
    client: "各顧客には、トランザクション データを分析し、顧客の成長ポイントを見つけるための <strong> プロフェッショナル サービス チーム</strong>、<br /> が配置されています。"
  },
  globalDeploy: {
    title: "グローバルなワンクリック導入",
    desc: ["6つの主要な世界的カード組織との協力関係を確立", "フランス、アルゼンチン、ブラジル、Cartes Bancaires、Cabal、Tarjeta Naranja、Elo のローカル デッキをサポート", "ヨーロッパ、北米、日本、韓国、東南アジア、香港、中国などで主流のローカライズされた支払いをサポートします。", "新しい BNPL (今すぐ購入、後で支払う) 製品をサポート"]
  },
  eco: {
    title: "エコロジー・アライアンス",
    subTitle: "支払いをもっと簡単に"
  },
  bizScenario: {
    mainTitle: "さまざまなビジネスシーンに適したオンライン決済",
    subTitle: "販売者がユーザー エクスペリエンスを最適化できるよう、包括的な支払いソリューションを販売者に提供します。",
    background: "背景",
    challenge: "チャレンジ",
    solution: "解決",
    onlineRetailers: {
      label: "電子商取引",
      mainTitle: "某DTC独立局が売れてます",
      subTitle: "伝統的な工業および貿易企業が国境を越えた電子商取引に変革するモデル",
      background: "顧客はキーボード製品に注力しており、ヨーロッパと米国で強いブランド影響力を持っています。",
      challenge: ["クレジットカード決済の成功率向上が急務", "現地での支払いを増やし、消費者のコンバージョン率と再購入率を向上させる", "会社の運営コストを節約するために、取得サービスとサプライヤーの支払いサービスの両方を提供できるパートナーを見つけたいと考えています。"],
      solution: ["世界的なアクワイアリング銀行のインテリジェントなルーティングにより、クレジット カードのアクワイアリングの成功率が大幅に向上します", "ヨーロッパと米国でローカライズされた支払い方法を提供することで、消費者は購入を完了するために独自に支払い方法を選択でき、コンバージョン率と再購入率が一目瞭然です。", "買収、サプライヤーの支払い、為替などを含むフルリンクの資金調達ソリューションを提供します。", "全天候型サービス: 24 時間年中無休のドッキング操作で質問に答えます"]
    },
    study: {
      label: "留学",
      mainTitle: "国内オンライン留学決済のリーダー",
      subTitle: "授業料、入学金、寮費などの国境を越えた支払い問題をワンストップで解決するサービスプラットフォーム。",
      background: "クライアントは、留学生に飲食、娯楽、旅行、娯楽などの優遇決済サービスを提供する留学生生活プラットフォームAPPを構築する予定です。",
      challenge: ["ヨーロッパやアメリカの海外学生にカード​​製本サービスを提供することが急務となっています。", "販売者のカテゴリごとに異なるアカウント共有ルールがあり、それらを販売者の地元の銀行口座に配布する必要があります。"],
      solution: ["カード所有者に完全なカード バインディングおよび控除機能を提供する", "プラットフォームと加盟店間のアカウント共有、視覚的な配信フロー、アカウント残高記録をサポートします。", "多通貨物流と強力な海外ルーティングにより、顧客の物流効率が大幅に向上"]
    },
    takeOutFood: {
      label: "テイクアウト",
      mainTitle: "世界をリードする中華料理配達プラットフォーム",
      subTitle: "華僑のケータリング業界のデジタル化プロセスの促進に尽力",
      background: "韓国の顧客、華僑へのサービスから地元グループへのサービスを拡大",
      challenge: ["カード、オンライン バンキング、ウォレットなどのすべての支払いタイプを含む、韓国現地の支払い方法が必要です。", "開発リソースは限られているため、すべてのドッキング方法を完了するために最小限の人員を投資したいと考えています。", "既存のレジに適応する必要がある"],
      solution: ["韓国の主要銀行8行、主要ウォレット3社、主流のオンラインバンキング、海外のデュアルスタンダードクレジットカードを提供", "販売者の開発リソース、カスタマイズのニーズ、配送速度に適応する"]
    },
    travel: {
      label: "旅行",
      mainTitle: "旅行業界のユニコーン",
      subTitle: "国際事業の拡大とグローバル化の加速",
      background: "顧客は、海外で現地カーサービス事業を迅速に展開し、海外ユーザーに旅行サービスを提供する必要があります。",
      challenge: ["海外の下請け業者やドライバーに対してKYBを行う必要がある", "各国で現地の支払い方法にアクセスすることが緊急に必要です", "旅行業界には海外地域ごとに異なる支払いルールがあり、専門的な経験が必要です。"],
      solution: ["KYB サービスを提供し、KYB プロセスを簡素化し、専門チームが顧客のオフライン完了を支援します", "東南アジア、ヨーロッパの顧客、華僑向けにローカライズされた支払い方法を提供する", "仮想商品の強力なトランザクション リスク制御により、顧客は支払いリクエストの成功率を向上させながらチャージバック率を制御できます。"]
    }
  },
  footerBlock: {
    title: "世界的な旅を始めましょう",
    register: "今すぐ登録してください"
  },
  footerCopy: {
    copyright: '2015-%{year} © PingPong 無断複写・転載を禁じます。'
  },
  product: {
    productTitle: "ピンポンチェックアウトを選択します",
    productIntro: "PingPong Checkout を使用すると、1 つのアカウントを使用してすべての独立したステーションの領収書を簡単に管理し、1 つの API を使用して 50 を超える通貨での取引を実装できます。",
    productSubIntro: "セキュリティと人間化に基づいて、より効率的な取得エクスペリエンスを得る",
    productIntroBtn: "今すぐ登録してください",
    listLanTitle: "成功率の向上",
    listLanP1: "複数の開発言語をサポート",
    listLanP2: "ページをリダイレクトせずに支払いが可能",
    listLanP3: "チャーンを減らす",
    listMbTitle: "モバイル ユーザー エクスペリエンスを最適化する",
    listMbP1: "最先端のモバイル SDK テクノロジー",
    listMbP2: "ApplePayとGooglePayを完全にサポート",
    listMbP3: "ユーザーエクスペリエンスの向上に貢献します"
  },
  serve: {
    serveTitle: "製品とサービス",
    serveList1: "トランザクション詐欺防止",
    serveList2: "国際クレジットカード決済ゲートウェイ",
    serveList3: "送金の一元決済",
    specialListTitle: "世界的に準拠した支払いシステム",
    specialListIntro1st: "中国、香港、米国、欧州、日本の決済ライセンスを保有する中国の数少ない国境を越えたアクワイアリング企業の 1 つ。",
    specialListIntro2nd: "広範な世界規模の協同組合銀行ネットワークを持っています",
    specialListIntro3rd: "国際的に権威のある第三者コンプライアンス評価機関から最高評価を長年連続して取得",
    specialRiskTitle: "世界をリードするリスク管理ソリューション",
    specialRiskIntro1st: "口座資金の安全を確保するための強力なリスク管理と不正行為防止システム",
    specialRiskIntro2nd: "3-D Secure",
    specialRiskIntro3rd: "PCI DSS 3.2認証",
    specialSettlementTitle: "親密な決済方法",
    specialSettlementIntro1st: "柔軟なマージン戦略",
    specialSettlementIntro2nd: "多様な決済手段",
    companyName: "杭州卓球智能科技有限公司"
  },
  pay: {
    payTitle: "海外決済",
    paySubTitle: "1つのAPIでモバイル端末とPC端末にアクセスして注文を取得できます。",
    paySubTitleSplit: "複数の主流通貨と国際クレジットカードを受け入れます",
    payItem1st: "国際クレジットカード",
    payItem2nd: "現地支払い",
    payItem3rd: "モバイル決済"
  },
  partner: {
    partnerTitle: "パートナー",
    faqTitle: "よくある質問"
  },
  faq: [{
    id: 1,
    category: "マーチャントドッキング",
    menu: [{
      id: 8,
      title: "オンラインにする前に",
      question: [{
        q: "PingPong チェックアウトの登録手順",
        a: ["1. 実名認証リンク：[アカウントセンター](右上)→[実名認証]をクリック", "2. 支払いアカウントの追加: [アカウント センター] (右上隅) をクリックします。", "3. Webサイトを追加：[Webサイト管理]をクリックします", "4. 2 番目のステップと 3 番目のステップには強い関連性はなく、順序は入れ替え可能です。"]
      }]
    }]
  }, {
    id: 2,
    category: "テストセッション",
    menu: [{
      id: 9,
      title: "Shopify ウェブサイト構築",
      question: [{
        q: "ショッピファイが更新されました。すべての決済サービス プロバイダーは、2022 年 7 月 31 日までに新バージョンのインストールを完了する必要があります。使用に影響はありますか?",
        a: "このヒントは、Shopify が決済プラットフォームをアップデートしているために提供されました。 PingPong Checkout は、新しい支払いアプリケーションをインストールするように一括して通知します。アップデートは 2022 年 6 月 30 日までに完了する予定です。アップデート後の決済サービスへの影響はありません。気長にお待ちください。私たちはあなたと連絡をとり、将来の切り替えを案内します。ご支援ありがとうございます"
      }, {
        q: "テストエラーの技術的理由",
        a: ["ウェブサイト構築プラットフォームの設定を確認してください", "1. テストモードが解除されているか？", "2. メールアドレスは設定されていますか？"]
      }, {
        q: "新しいバージョンをインストールすると、ページ カードが表示されなくなります。",
        a: "Shopify Webサイトを構築して更新すると、Webページのカードマークは表示されなくなりますが、顧客の注文は通常どおり表示されます。 pingpong は最適化のために shopify と連絡を取りました。"
      }]
    }, {
      id: 10,
      title: "Shoplazza",
      question: [{
        q: "お店の職人さんはどうやって取り付けているのでしょうか？",
        a: "こんにちは。PingPong Checkout バックエンド: https://checkout.pingpongx.com/ に移動し、[システム管理] メニューの [キー設定] から関連パラメーターを取得し、特定のストア ID、クライアント ID、およびキーを Dianjiang バックエンドにコピーする必要があります。 [マーチャント ID にはクライアント ID を入力し、アカウント ID には accID を入力します]"
      }]
    }, {
      id: 11,
      title: "self-build",
      question: [{
        q: "自作ウェブサイトのドッキングプロセス",
        a: "初期段階では、双方の技術担当者が技術的なドッキングに参加し、サンドボックス環境のテストを完了する必要があります。承認後、運用学生は運用環境の構成とテストを完了します。"
      }]
    }, {
      id: 12,
      title: "テスト",
      question: [{
        q: "ストアテスト",
        a: "こんにちは。自分でテストするか、その後のトランザクションに注意を払うことをお勧めします。テストを支援するためにピンポンが必要な場合は、1 ドルのテスト リンクを提供してください。 (現在、V/M カードのテストのみがサポートされています。現地の銀行カード決済やその他のカード ブランドが関係する場合、動作はテストできません)"
      }]
    }]
  }, {
    id: 3,
    category: "注文関連",
    menu: [{
      id: 13,
      title: "支払方法",
      question: [{
        q: "PingPong Checkout は現在どのような支払い方法をサポートしていますか?",
        a: "現在サポートされているカード ブランドは次のとおりです: VISA、Mastercard、JCB、DinersClub、Discover、American Express (ローカライズされた支払いを追加する必要がある場合は、営業マネージャーにお問い合わせください)"
      }]
    }, {
      id: 14,
      title: "支払いエラー（よくある質問）",
      question: [{
        q: "PingPong Checkout 販売者バックエンド、注文失敗理由のクエリ パス",
        a: "トランザクション管理 -- トランザクション クエリ -- Web サイトの注文番号/トランザクション シリアル番号を入力 -- 青色のトランザクション シリアル番号をクリックして、特定の失敗の理由を表示します"
      }, {
        q: "Do not honor",
        a: "こんにちは。取引制限、カード発行会社に対する不信感、またはクレジット カードの国境を越えた取引制限があるため、カード所有者はカード発行会社に連絡するか、支払い用のカードを変更する必要があります。"
      }, {
        q: "3D 検証に失敗しました/3D 検証に失敗しました",
        a: "こんにちは。カード所有者がこの注文の支払いを行う際、詐欺の可能性などのセキュリティ上の問題により、指紋認証、顔認証、または SMS 認証を実行する必要がありました。カード所有者の認証に失敗しました。情報を入力した後は支払いページを閉じないでください。また、情報が正しく入力されていることを確認する必要があります。"
      }, {
        q: "Transaction declined（invalid card/cardholder authentication verification failure/limit exceeded/expired card）",
        a: "こんにちは。カード発行会社から「カードが無効です/カード所有者の認証に失敗しました/支払い金額が限度額を超えています/カードの有効期限が切れています」というメッセージが返されるため、カード所有者はカードの有効な認証情報を確認することをお勧めします。"
      }, {
        q: "Transaction declined（High risk transaction）",
        a: "こんにちは。このトランザクションはリスク管理によって危険であると検出されたため、拒否されました。"
      }, {
        q: "Transaction declined(other reason)",
        a: "こんにちは。このようなエラーが発生した場合は、WeChat グループまたは営業マネージャーに報告して、問題解決の支援を依頼してください。"
      }, {
        q: "Received external system response timeout",
        a: "こんにちは、システムがタイムアウトになり、注文がクローズされました。注文を生成した後、カード所有者はできるだけ早く支払いを完了する必要があります。そうしないと注文がタイムアウトして失敗します。"
      }, {
        q: "返金が届くまでにどのくらい時間がかかりますか?",
        a: "具体的な返金時間は、カード発行銀行のクレジット カードの速度によって異なります。通常、7営業日から1か月程度かかります。カード所有者は、確認のためにカード発行銀行に問い合わせることをお勧めします。"
      }, {
        q: "返金に失敗しました",
        a: ["払い戻しの失敗は次の状況で発生します。", "1. カード所有者がこの注文に対してチャージバックを開始したため、返金はできません。", "2. 返金時間が銀行の制限を超えた場合 (通常は 180 日、銀行ごとに時間が異なる場合があります)", "3. カード発行会社はロシア、ウクライナ、その他の制裁対象国への返金を怠った。", "4. 上記の理由に加えて、PS で始まる支払い注文番号をグループ内の運営に提供してください。運営がフォローして問題を解決します。"]
      }]
    }, {
      id: 15,
      title: "注文状況",
      question: [{
        q: "トランザクションの種類は承認済み (approved)、ステータスは成功です。なぜ和解が成立しないのでしょうか？",
        a: "取引タイプが承認 (Approve) および拒否 (Reject) された注文は、すべてリスク注文の監査注文です。対応するトランザクションタイプはそれぞれConsumption_Success、Consumption_Cancelとなり、決済には含まれません。取引を確認して注文を決済するときは、消費注文の取引タイプに従うだけで済みます。"
      }, {
        q: "検討すべき注文（検討）",
        a: "通常、24 時間以内に処理されます"
      }, {
        q: "注文を拒否する",
        a: "注文の支払いが拒否された場合は、メールを確認するか、PingPong Checkout バックエンドの [リスク管理] - [注文拒否管理] で取引を見つけて異議を申し立てることができます。まず購入者に連絡することをお勧めします。"
      }, {
        q: "システム内のリスク注文を確認するにはどうすればよいですか?",
        a: "PingPong Checkout バックエンド、リスク管理 - リスク注文管理にログインすると、クエリを実行できます。"
      }, {
        q: "顧客が注文すると、注文ステータスは保留中と表示されます。 Pingpong バックエンドでトランザクションが見つからない可能性はありますか?",
        a: "保留中の注文は、ユーザーが支払いを開始しておらず、レジページを要求しただけであることを意味します。"
      }]
    }]
  }, {
    id: 4,
    category: "出金",
    menu: [{
      id: 16,
      title: "アカウント設定",
      question: [{
        q: "VAアカウントの追加方法",
        a: "こんにちは。PingPong Checkout バックエンド - [アカウント センター] - 右上隅の [引き出しアカウント] に VA を直接追加できます。 「VA出金操作ガイド」をご覧ください。"
      }, {
        q: "銀行口座を追加する方法",
        a: "通常、パブリック アカウントが必要であり、米ドルがサポートされています。"
      }]
    }, {
      id: 17,
      title: "アカウントのレビュー",
      question: [{
        q: "出金口座の審査期限",
        a: "VA 出金口座の場合、手動での確認は必要ありません。他の銀行口座を追加するには、営業マネージャーに連絡してフィードバックを提供し、リスク管理レビューに合格する必要があります。"
      }]
    }, {
      id: 18,
      title: "到着までの制限時間",
      question: [{
        q: "出金を開始してから到着するまでどのくらい時間がかかりますか?",
        a: "出金がアカウントに届くまでには通常 1 ～ 3 営業日かかります。 VA 口座にお金を引き出すと、同じ日に届きます。"
      }]
    }, {
      id: 19,
      title: "割り当てが不十分です",
      question: [{
        q: "VAの出金、ピンポンメインサイトへの出金額が足りません",
        a: ["人民元為替決済のご要望があった場合、", "1. 時間内に物流プラグインをバインドし、PingPong Checkout バックグラウンド引き出しアカウントに仮想アカウント (通貨: USD) を追加してください。", "2. 注文管理 - 未アップロードステータスの注文のクエリ - このアップロードステータスの現在の判断ロジックでは、緑色のアップロードステータスが表示される前に製品名と物流注文番号を入力する必要があります。システムが販売者名を取得できない場合は、手動で入力する必要があります。"]
      }]
    }]
  }, {
    id: 5,
    category: "料金・お見積り",
    menu: [{
      id: 20,
      title: "料金徴収",
      question: [{
        q: "手数料はどのように請求されますか?",
        a: "こんにちは。手数料は固定手数料と比例配分に基づいて計算されます。詳細につきましては、契約料金をご覧いただくか、営業担当者までお問い合わせください。"
      }, {
        q: "チャージバック手数料はどのように請求されますか?",
        a: "こんにちは。契約書に記載されている不払い手数料についてご確認ください。特定の注文に関してご不明な点がございましたら、お問い合わせの際にトランザクション シリアル番号をお知らせください。"
      }, {
        q: "出金手数料を差し引くためのルールは何ですか?",
        a: "出金手数料 (契約書を参照してください) は、販売者が開始した出金金額から差し引かれます。販売者が出金金額を入力すると、手数料の金額と実際に受け取った金額が表示されます。"
      }, {
        q: "回転証拠金とは何ですか？",
        a: "リボルビング証拠金とは、各取引金額の 10% が請求される合計証拠金を指します。 180日後に解除され、出金可能額に含まれます（詳細は契約書をご覧ください）"
      }, {
        q: "支払い拒否警告手数料",
        a: "こんにちは。チャージバック警告メカニズムは、不正なチャージバックが開始されようとしているとシステムが認識すると、注文を返金するというものです。返金後、注文はチャージバック注文ではなく返金注文に変換されるため、チャージバック率が下がります。この操作にはチャージバック警告料金が請求されます。"
      }]
    }, {
      id: 21,
      title: "声明",
      question: [{
        q: "和解の問題",
        a: "こんにちは。調整はバックグラウンド レポート管理からダウンロードされた月次資金明細書に基づいています。調整についてはこのディメンションを参照してください。 (フィードバックステートメントの詳細とウェブサイト構築ツールの背景に違いがある場合は、違いの順序リストを提供してください。技術的な位置付けの問題を報告します)"
      }, {
        q: "明細書に表示されるチャージバックが他の明細期間と一致しないのはなぜですか?",
        a: "こんにちは。取引および返金に関する明細書は、契約の決済サイクルに基づいています。チャージバックが発生した場合、それも含まれます。"
      }]
    }, {
      id: 22,
      title: "決済",
      question: [{
        q: "元の通貨での決済",
        a: "こんにちは、担当営業にお問い合わせください"
      }, {
        q: "決済はいつ行われますか?",
        a: "契約書の決済サイクルを参照してください。国内祝日やチャンネル休日の場合は決済が延期されます。"
      }]
    }]
  }, {
    id: 6,
    category: "ロジスティクス",
    menu: [{
      id: 23,
      title: "物流プラグイン",
      question: [{
        q: "バインド方法",
        a: ["Shopify/Shoplazza上に構築されたストアの場合、物流注文番号を自動的に取得できます。具体的な操作方法は以下の通りです。", "1) PingPong Checkout Web サイト管理に入ります。", "2) 右側の省略記号をクリックし、「ロジスティック バインディング」を選択します。", "3) Shopify バックエンド管理アカウントのドメイン名を入力します。", "4) Shopify アカウントにログインした後、指示に従って PingPong Checkout アプリケーションをインストールします。"]
      }]
    }]
  }, {
    id: 7,
    category: "組織のルール",
    menu: [{
      id: 24,
      title: "組織のルール",
      question: [{
        q: "AMEX Merchant Rules",
        a: "<a href=\"https://cdn17.pingpongx.com/static_platform/acquirer/AMEXMerchantRules.html\" target=\"_blank\" style=\"color: #2288E3;\">詳細を見る</a>"
      }, {
        q: "Klarna Merchant Rules",
        a: "<a href=\"https://cdn17.pingpongx.com/static_platform/acquirer/KlarnaMerchantRules.html\" target=\"_blank\" style=\"color: #2288E3;\">詳細を見る</a>"
      }, {
        q: "Prohibited Business",
        a: "<a href=\"https://cdn17.pingpongx.com/static_platform/acquirer/ProhibitedBusiness.html\" target=\"_blank\" style=\"color: #2288E3;\">詳細を見る</a>"
      }, {
        q: "iDeal Merchant Rules",
        a: "<a href=\"https://cdn17.pingpongx.com/static_platform/acquirer/iDealMerchantRules.html\" target=\"_blank\" style=\"color: #2288E3;\">詳細を見る</a>"
      }, {
        q: "Sofort Merchant Rules",
        a: "<a href=\"https://cdn17.pingpongx.com/static_platform/acquirer/SofortMerchantRules.html\" target=\"_blank\" style=\"color: #2288E3;\">詳細を見る</a>"
      }]
    }]
  }]
};
export default ja;
